import type { BoxId } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface HighlightBoxCommand {
  boxId: BoxId;
}

export const highlightBox: GraphCommandFactory<HighlightBoxCommand> =
  (cmdContext) => (command) => {
    cmdContext.eventEmitter.emit('highlightBox', { boxId: command.boxId });
  };
